module.exports = __webpack_public_path__ + "static/img/btn_google_signin_light_normal_web@2x.52a05e73.png";